import React, { Fragment, useRef } from "react";
import _ from "lodash";

import CpapTrialRegisterFields from "./CpapTrialRegisterFields";
import { cpapTrialExternalRepairFields } from "./cpapTrialExternalRepairFields";

export const CpapTrialExternalRepairForm = (props) => {
  const renderFields = () => {
    return _.map(
      cpapTrialExternalRepairFields,
      ({ label, name, type, options, required, description }) => {
        return (
          <CpapTrialRegisterFields
            key={name}
            name={name}
            label={label}
            type={type}
            options={options}
            required={required}
            initailValue={
              props.initialValues ? props.initialValues[name] : null
            }
            onChange={props.onChange(name)}
            disabled={props.disabled}
            description={description}
            viewonly={props.viewonly}
          />
        );
      }
    );
  };

  return <Fragment>{renderFields()}</Fragment>;
};
